<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  showMember: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();
</script>

<template>
  <div class="d-flex bg-surface-lighten-1">
    <div class="p-dictionary__checkcell">
      <v-checkbox
        :model-value="props.modelValue"
        density="compact"
        hide-details
        @update:model-value="emit('update:modelValue', !!$event)"
      />
    </div>
    <div class="p-dictionary__cell is-word">変換前</div>
    <div class="p-dictionary__cell is-word">変換後</div>
    <div
      v-if="props.showMember"
      class="p-dictionary__cell is-user"
    >
      登録者
    </div>
  </div>
</template>
